import React, {
  lazy,
  Suspense,
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react";
import { Label } from "@mbo/forms";
import AccordionClose from "../../../icons/accordionClose.component";
import AccordionOpen from "../../../icons/accordionOpen.component";
import { AccordionWrapper, LabelWrapper } from "./accordion.style";
const AccordionBase = lazy(() =>
  import("@mbo/form-advanced").then((module) => ({
    default: module.Accordion,
  })),
);

const Accordion = ({ children, idx, title, ...rest }) => {
  const [open, setOpen] = useState(false);
  const accordionRef = useRef(null);
  const realOpen = useMemo(() => open || rest.isOpen, [open, rest.isOpen]);

  useEffect(() => {
    if (!realOpen) return;

    accordionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [realOpen]);

  return (
    <Suspense>
      <AccordionWrapper ref={accordionRef}>
        {idx !== 0 && (
          <div className="divider">
            <div></div>
          </div>
        )}
        <AccordionBase
          iconSize="lg"
          index={idx}
          isRounded
          variant="default"
          isOpen={open}
          setIsOpen={setOpen}
          onOpenIcon={<AccordionClose />}
          onCloseIcon={<AccordionOpen />}
          title={
            <LabelWrapper>
              <Label size="lg" variant="dark">
                {title}
              </Label>
            </LabelWrapper>
          }
          {...rest}
        >
          {children}
        </AccordionBase>
      </AccordionWrapper>
    </Suspense>
  );
};

export default Accordion;
